var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalesChannel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.02 53.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#124fc9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.51,
    cy: 6.19,
    r: 6.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23,24.74H40a2.53,2.53,0,0,0,2.41-3.27,11.42,11.42,0,0,0-21.88,0A2.53,2.53,0,0,0,23,24.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 11.05,
    cy: 34.73,
    r: 6.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.05,41.87A11.42,11.42,0,0,0,.11,50a2.53,2.53,0,0,0,2.41,3.28H19.58A2.53,2.53,0,0,0,22,50,11.41,11.41,0,0,0,11.05,41.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.97,
    cy: 34.73,
    r: 6.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.91,50A11.42,11.42,0,0,0,41,50a2.53,2.53,0,0,0,2.41,3.28H60.5A2.53,2.53,0,0,0,62.91,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.94,38.63,31.51,29.2l-9.43,9.43a2.16,2.16,0,1,0,3.05,3l6.38-6.38,6.37,6.38a2.17,2.17,0,0,0,3.06,0A2.16,2.16,0,0,0,40.94,38.63Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesChannel);
export default __webpack_public_path__ + "static/media/sales-channel.778a3586e4ba6a1256d36e89e911b929.svg";
export { ForwardRef as ReactComponent };